import apiBase from "@/api/unversioned/apiBase";
import { type AxiosRequestConfig } from "axios";

const baseURL = `${import.meta.env.VITE_API_BASE_URL}/upload/report`;

const post = async (path: string, requestBody: any, config?: AxiosRequestConfig) => {
  return apiBase("post", baseURL + path, config, requestBody);
};

export default { post };
